var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"captcha-fake-wrapper pb-4"},[_c('v-checkbox',{staticClass:"mb-0 pt-0",attrs:{"label":_vm.label,"hide-details":""},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}}),_c('div',{staticClass:"pt-3"},[_c('img',{staticClass:"captcha-icon ml-3",attrs:{"src":_vm.captcha,"alt":"captcha"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }